import { useTranslation } from "react-i18next";

import { MapiqMapMessage } from "./MapiqMapMessage";

export const MapiqMapError = () => {
  const { t } = useTranslation();

  return <MapiqMapMessage>{t("error:FailedToDisplayMap")}</MapiqMapMessage>;
};
